import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./LogMedication.css";

const MEDICATION_TYPES = ["Topical Corticosteroids", "Emollients/Moisturizers", "Antihistamines", "Biologics", "Topical Calcineurin Inhibitors", "Antibiotics", "Oral Corticosteroids", "Other"];

const LogMedication = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const [medicationType, setMedicationType] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const handleLog = () => {
    // Medication logging - UI only
  };

  return (
    <section className="log-med-page">
      <div className="log-med-container">
        <div className="log-med-field">
          <label className="log-med-label">{t("logMedication.typeLabel")}</label>
          <select
            className="log-med-select"
            value={medicationType}
            onChange={(e) => setMedicationType(e.target.value)}
          >
            <option value="">{t("logMedication.selectType")}</option>
            {MEDICATION_TYPES.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
        <div className="log-med-field">
          <label className="log-med-label">{t("logMedication.timeLabel")}</label>
          <input
            type="time"
            className="log-med-input"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>
      </div>
      <section className="log-med-bottom">
        <button
          className="log-med-btn"
          disabled={!medicationType || !time}
          onClick={handleLog}
        >
          {t("logMedication.logBtn")}
        </button>
      </section>
    </section>
  );
};

export default LogMedication;
